/* eslint-disable react/prop-types */
import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from 'react';
import { Collapse } from 'reactstrap';
import { toast } from 'react-hot-toast';

import { ProductsTable } from './styles';
import api from '~/services/api';
import ItemProductsIfood from '~/components/Products/ItemProductsIfood';
import { useAuth } from '~/context/AuthContext';
import { useMenu } from '~/context/OrderingSystem/Menu';
import { useInView } from 'react-intersection-observer';

const ProductsTablesIfood = (
  {
    category,
    user,
    getCategories,
    menewProducts,
    categories,
    cache,
    setCategoriesFiltered,
    setCategories,
    setComplementsCategories,
    complementCategories,
    fiscalGroups,
    ifoodMenus,
    ifoodRestaurants,
    ifoodProducts,
  },
  ref
) => {
  const [isOpen, setIsOpen] = useState(true);
  const { user: restaurant } = useAuth();
  const [products, setProducts] = useState(category?.products || []);
  const { getMenu } = useMenu();

  const toggle = () => setIsOpen((prev) => !prev);

  useEffect(() => {
    setProducts(category?.products || []);
    setVisibleProducts(15); // reset ao trocar categoria
  }, [category]);

  function setProductsState(data) {
    setProducts((state) => [...state, data]);
  }

  useImperativeHandle(ref, () => ({
    setProductsState,
    products,
    toggle,
  }));

  async function handleDelete(id) {
    try {
      if (window.confirm('Tem certeza que deseja deletar este produto?')) {
        await api.delete(`/restaurants/products/${id}`);

        const productsFiltered = products.filter(
          (product) => product.id !== id
        );

        const catFind = categories.findIndex((cat) => cat.id === category.id);
        if (catFind !== -1) {
          categories[catFind].products = productsFiltered;
        }

        setProducts(productsFiltered);
        getMenu();

        toast.success('Produto deletado com sucesso!');
        localStorage.setItem('@gddashboard:isMenuUpdated', true);
      }
    } catch (error) {
      toast.error('Erro ao deletar produto');
    }
  }

  // ===== Infinite Scroll =====
  const [visibleProducts, setVisibleProducts] = useState(15);

  const { ref: sentinelRef, inView } = useInView({
    threshold: 0,
    rootMargin: '300px', // dispara antes de chegar no final
  });

  useEffect(() => {
    if (inView) {
      setVisibleProducts((prev) => {
        if (prev >= products.length) return prev; // já mostrou tudo
        return prev + 15;
      });
    }
  }, [inView, products.length]);

  const productList = products.slice(0, visibleProducts);

  return (
    <Collapse isOpen={isOpen}>
      <ProductsTable responsive borderless>
        <thead>
          <tr>
            <th>Item</th>
            {!restaurant?.only_delivery && <th>Preço</th>}
            <th>iFood</th>
            <th />
          </tr>
        </thead>

        <tbody>
          {productList.map((product, index) => (
            <ItemProductsIfood
              key={product.id}
              product={product}
              category={category}
              handleDelete={handleDelete}
              is_priority={user.is_priority}
              getCategories={getCategories}
              index={index}
              menewProducts={menewProducts}
              setProducts={setProducts}
              products={products}
              categories={categories}
              setCategoriesFiltered={setCategoriesFiltered}
              setCategories={setCategories}
              setComplementsCategories={setComplementsCategories}
              complementCategories={complementCategories}
              fiscalGroups={fiscalGroups}
              ifoodMenus={ifoodMenus}
              ifoodRestaurants={ifoodRestaurants}
              ifoodProducts={ifoodProducts}
              use_ifood_pdv_code={user.use_ifood_pdv_code}
            />
          ))}

         
          {visibleProducts < products.length && (
            <tr>
              <td colSpan={5}>
                <div
                  ref={sentinelRef}
                  style={{ height: 40 }}
                />
              </td>
            </tr>
          )}
        </tbody>
      </ProductsTable>
    </Collapse>
  );
};

export default forwardRef(ProductsTablesIfood);
